/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import {
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  IconButton,
} from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';
import { styled } from '@mui/material/styles';

const CssFormControl = styled(FormControl)({
  '& label.Mui-focused': {
    color: '#84d8c5',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#84d8c5',
  },
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused fieldset': {
      borderColor: '#84d8c5',
    },
  },
});

export const Search = (props) => {
  return (
    <CssFormControl size="small" sx={{ width: '32ch' }} variant="outlined">
      <InputLabel htmlFor="search-field-input">Search</InputLabel>
      <OutlinedInput
        id="search-field-input"
        type="text"
        fullWidth
        value={props.searchValue}
        onChange={props.onChange}
        endAdornment={
          <InputAdornment position="end">
            <IconButton onClick={props.handleSearch} edge="end">
              <SearchIcon />
            </IconButton>
          </InputAdornment>
        }
        label="Search"
      />
    </CssFormControl>
  );
};
